import { render, staticRenderFns } from "./sucesso-solicitacao-instituicao.vue?vue&type=template&id=84703ea8&"
import script from "./sucesso-solicitacao-instituicao.vue?vue&type=script&lang=js&"
export * from "./sucesso-solicitacao-instituicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports